import { Badge, Drawer, Modal, Select, Tooltip, message } from "antd";
import React, { useEffect, useState } from "react";
import NotificationsIcon from "../../Assets/Images/Svg/Notification.svg";
import { useHistory, useLocation } from "react-router-dom";
import { FaStar, FaUser } from "react-icons/fa";
import MyProfile from "../Pages/MyProfile";
import hamburger from "../../Assets/Images/hamburger.png";
import doxzonlogo from "../../Assets/logo/DoxzonLogoWhitebackground.svg";
import UserService from "../../Services/UserService";
import { APP_ROUTES } from "../../PageRouting/approutes";
import { IoIosChatboxes, IoMdNotifications } from "react-icons/io";
import LiveChat from "../Pages/LiveChat/chat";
import { useDispatch, useSelector } from "react-redux";
import { countUnreadMessages } from "../../Services/chatService";
import ClinicY from "../../Assets/Images/Svg/Clinic-Y1.svg";
import ClinicN from "../../Assets/Images/Svg/Clinic-N1.svg";
import chat from "../../Assets/Icons/chat.svg";
import profileHover from "../../Assets/Images/profileHover.png";
import profileIcon from "../../Assets/Images/profileIcon.svg";
import profileLogout from "../../Assets/Images/profileLogout.svg";
import {
  GETNOTIFICATIONCOUNT,
  getNotificationCount,
} from "../../Redux/actions/NotificationActions";
import { GETCOUNT } from "../../Redux/actions/ChatActions";
import { SET_ROUTE, SHOWALERTTRUE } from "../../Redux/actions/CommonActions";
import { clearLoggedUser } from "../../Redux/actions/UserActions";
import { IoPersonAdd } from "react-icons/io5";
import RPMPatientRegistration from "../Pages/Patients/AddNewPatient";
import { setSelectedEditPatient } from "../../Redux/actions/patientActions";
// import DoctorLiveChat from "../Pages/LiveChatNew";

function Header({ handleSideBarMenu }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [profileData, setProfileData] = useState(null);
  const [chatOpen, setChatOpen] = useState(false);
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);

  const location = useLocation();
  const loggedUserJson = sessionStorage.getItem("login_result");
  const loggedUser = loggedUserJson ? JSON.parse(loggedUserJson) : null;
  const dispatch = useDispatch();
  const totalnotifyCount = useSelector((state) => state.chatCount.count);
  const [clinicList, setClinicList] = useState([]);
  const [clinicModal, setClinicModal] = useState(false);
  const [selectedClinic, setSelcetedClinic] = useState({});
  const notificationCount = useSelector(
    (state) => state.notificationCount.count,
  );
  const { alert, route } = useSelector((state) => state.common);
  const [registrationModal, setRegistrationModal] = useState(false);

  useEffect(() => {
    getNotiCount();
  }, []);

  const getNotiCount = async () => {
    try {
      let countStatus = await dispatch(getNotificationCount());
    } catch (e) {
      console.error(e);
    }
  };

  const showClinicModal = (clinic) => {
    if (clinic.defaultClinic == "Y") {
      message.warning(`${clinic.clinicName} is Default Clinic`);
      return;
    } else {
      setSelcetedClinic(clinic);
      setClinicModal(true);
    }
  };

  const handleClinicOk = async () => {
    let payload = {
      account_Id: loggedUser.user.account_Id,
      clinic_Id: selectedClinic.clinic_Id,
      userId: loggedUser.user.userId,
    };

    try {
      let result = await UserService.UpdateDefaultClinic(payload);
      if (result.data == 1) {
        sessionStorage.setItem("defaultClinic", payload.clinic_Id);
        const loginData = sessionStorage.getItem("login_result");
        const parsedLoginData = loginData ? JSON.parse(loginData) : null;
        const updatedData = {
          ...parsedLoginData,
          user: {
            ...parsedLoginData.user,
            clinic_Id: payload.clinic_Id,
          },
        };
        sessionStorage.setItem("login_result", JSON.stringify(updatedData));
        const selected = clinicList.find(
          (clinic) => clinic.clinic_Id === payload.clinic_Id,
        );
        setDefaultClicnic(selected);
        window.location.reload();
      } else {
        message.error("An Error Occured");
      }
    } catch (error) {
      message.error("An Error Occured");
    }
    setClinicModal(false);
  };
  const handleClinicCancel = () => {
    setClinicModal(false);
  };

  // useEffect(() => {
  //   if (loggedUser) {
  //     const fetchMsgCount = async () => {
  //       const msgCount = await countUnreadMessages(loggedUser.user.userId);
  //       dispatch({ type: GETCOUNT, payload: msgCount });
  //     };
  //     fetchMsgCount();
  //   }
  // }, []);

  useEffect(() => {
    if (!loggedUser) return;

    const unsubscribe = countUnreadMessages(loggedUser.user.userId, dispatch);

    // VERY IMPORTANT: cleanup listener
    return () => {
      if (typeof unsubscribe === "function") {
        unsubscribe();
      }
    };
  }, [loggedUser, dispatch]);

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const handleLogout = () => {
    if (location.pathname === APP_ROUTES.VIDEOCALL) {
      dispatch({ type: SHOWALERTTRUE });
      dispatch(clearLoggedUser(null));
      dispatch({ type: SET_ROUTE, payload: APP_ROUTES.LOGINFORM });
    } else {
      sessionStorage.clear();
      history.push(APP_ROUTES.LOGINFORM);
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const showRegistrationModal = () => {
    dispatch(setSelectedEditPatient(null));
    setRegistrationModal(true);
  };

  const handleRegistrationCancel = () => {
    setRegistrationModal(false);
  };

  useEffect(() => {
    const loginData = sessionStorage.getItem("login_result");
    const parsedLoginData = loginData ? JSON.parse(loginData) : null;
    setProfileData(parsedLoginData);
  }, []);

  const handleNavigation = (route) => {
    if (location.pathname === APP_ROUTES.VIDEOCALL) {
      dispatch({ type: SHOWALERTTRUE });
      dispatch({ type: SET_ROUTE, payload: route });
    } else {
      history.push(route);
    }
  };

  const handleChatOpen = () => {
    setChatOpen(true);
  };

  const handleChatClose = () => {
    setChatOpen(false);
  };
  const getClincListDetails = async () => {
    const defaultData = sessionStorage.getItem("defaultClinic");
    let payload = {
      userId: loggedUser.user.userId,
      status: 1,
    };
    try {
      let result = await UserService.UserMultipleClinicList(payload);
      setClinicList(result?.data[0]?.clinicDetailsList);
      const defaultClinic = result?.data[0]?.clinicDetailsList.find(
        (clinic) => clinic.clinic_Id == defaultData,
      );
      setDefaultClicnic(defaultClinic);
    } catch (error) {
      console.error("error", error);
    }
  };
  useEffect(() => {
    getClincListDetails();
  }, []);

  const [defaultClinic, setDefaultClicnic] = useState();

  const handleClinicChange = (value) => {
    const defaultData = sessionStorage.getItem("defaultClinic");

    if (defaultData == value) {
      return;
    }

    sessionStorage.setItem("defaultClinic", value);
    const loginData = sessionStorage.getItem("login_result");
    const parsedLoginData = loginData ? JSON.parse(loginData) : null;
    const updatedData = {
      ...parsedLoginData,
      user: {
        ...parsedLoginData.user,
        clinic_Id: value,
      },
    };
    sessionStorage.setItem("login_result", JSON.stringify(updatedData));
    const selected = clinicList.find((clinic) => clinic.clinic_Id === value);
    setDefaultClicnic(selected);
    window.location.reload();
  };

  return (
    <div className="flex items-center h-[70px] bg-[#F1FFF9]">
      <div className="flex items-center border-brand-textGray gap-5 mx-2 w-1/2">
        <img
          src={hamburger}
          alt="icon"
          className="w-5 cursor-pointer hidden md:block"
          onClick={handleSideBarMenu}
        />

        <img
          src={hamburger}
          alt="icon"
          className="w-5 cursor-pointer md:hidden block"
          onClick={showDrawer}
        />
        <img src={doxzonlogo} alt="logo" className="w-40 h-10" />
      </div>
      <div className="md:w-1/2 flex justify-end mr-10 gap-5">
        <div className="flex items-center justify-end">
          <div className="flex items-center gap-3">
            {loggedUser?.user?.dietChartApplicableYN === "Y" && (
              <div>
                <button
                  className="g-brand-primaryColor text-white px-3 py-1 rounded-md text-sm font-semibold"
                  onClick={() => handleNavigation(APP_ROUTES.DIETPLAN)}
                >
                  Diet
                </button>
              </div>
            )}
            {loggedUser?.user?.rpmApplicable === "Y" && (
              <div className="flex items-center gap-3">
                <button
                  className="bg-brand-primaryColor text-white px-3 py-1 rounded-md text-sm font-semibold"
                  onClick={() => {
                    if (location.pathname === APP_ROUTES.VIDEOCALL) {
                      dispatch({ type: SHOWALERTTRUE });
                      dispatch({
                        type: SET_ROUTE,
                        payload: APP_ROUTES.PATIENTS,
                      });
                    } else {
                      history.push(APP_ROUTES.PATIENTS, { filterRPM: true });
                    }
                  }}
                >
                  RPM
                </button>
                <div className="mx-2">
                    {location.pathname !== APP_ROUTES.RPMPATIENTPALLETTE && (
                      <Tooltip title="Add New Patient" placement="top">
                        <IoPersonAdd
                          className="w-5 h-5 cursor-pointer text-brand-primaryColor"
                          onClick={showRegistrationModal}
                        />
                      </Tooltip>
                    )}
                </div>
              </div>
            )}
            <div>
              <Tooltip title="Favorite Medicine" placement="top">
                <FaStar
                  className="w-4 h-4 text-yellow-400 cursor-pointer"
                  onClick={() => handleNavigation(APP_ROUTES.FAVMEDICINE)}
                />
              </Tooltip>
            </div>

            <Select
              disabled={location.pathname === APP_ROUTES.VIDEOCALL}
              value={defaultClinic?.clinic_Id}
              onChange={handleClinicChange}
              className="w-56 h-8"
              suffixIcon={null}
            >
              {clinicList?.map((clinic) => (
                <Select.Option key={clinic.clinic_Id} value={clinic.clinic_Id}>
                  {clinic.clinicName}
                </Select.Option>
              ))}
            </Select>
            {defaultClinic && (
              <img
                onClick={(e) => {
                  if (location.pathname === APP_ROUTES.VIDEOCALL) {
                    return;
                  }
                  e.stopPropagation();
                  showClinicModal(defaultClinic);
                }}
                src={defaultClinic.defaultClinic === "Y" ? ClinicY : ClinicN}
                alt="img"
                className="w-8 h-8 cursor-pointer"
              />
            )}
            <div className="mx-2">
              <Tooltip title="Notification" placement="top">
                <Badge count={notificationCount > 0 ? notificationCount : null}>
                  {/* <img
                    src={NotificationsIcon}
                    alt="Notification"
                    className="w-6 h-6 cursor-pointer"
                    onClick={() => handleNavigation(APP_ROUTES.NOTIFICATION)}
                  /> */}
                  <IoMdNotifications
                    className="w-6 h-6 cursor-pointer mt-2 text-brand-primaryColor"
                    onClick={() => handleNavigation(APP_ROUTES.NOTIFICATION)}
                  />
                </Badge>
              </Tooltip>
            </div>
            <Tooltip title="Chats">
              <Badge className="w-6 h-6 relative cursor-pointer">
                {totalnotifyCount > 0 && (
                  <div className="bg-red-600 rounded-full text-white text-[10px] font-semibold text-center flex justify-center items-center max-w-max min-w-5 w-5 h-5 absolute bottom-[15px] left-[10px]">
                    {totalnotifyCount > 99 ? "99+" : totalnotifyCount}
                  </div>
                )}
                <img
                  src={chat}
                  alt=""
                  className="w-8 h-8"
                  onClick={handleChatOpen}
                />
              </Badge>
            </Tooltip>
            <div className="hidden group relative md:block cursor-pointer paste-button">
              {loggedUser.user.imageName ? (
                <div className="rounded-full  md:w-12 w-24 md:h-12 h-24 ml-6 flex justify-center items-center">
                  <img
                    src={
                      process.env.REACT_APP_IMAGE_URL +
                      loggedUser.user.imageName
                    }
                    alt="DocImg"
                    className="rounded-full md:w-12 w-6 md:h-12 h-6"
                  />
                </div>
              ) : (
                <div className="rounded-full border border-brand-secondaryColor md:w-12 w-10 md:h-12 h-10 ml-6 flex justify-center items-center">
                  <FaUser className="md:w-8 w-6 md:h-8 h-6" />
                </div>
              )}

              <div className="hidden group-hover:block z-10 absolute rounded-md  border-2 top-10 w-72 bg-white p-2 right-3">
                <div
                  className="p-2 bg-cover flex flex-col gap-2 items-center justify-center rounded-md bg-center"
                  style={{ backgroundImage: `url(${profileHover})` }}
                >
                  {loggedUser.user.imageName ? (
                    <div className="rounded-full mt-2 md:w-12 w-24 md:h-12 h-24  flex justify-center items-center">
                      <img
                        src={
                          process.env.REACT_APP_IMAGE_URL +
                          loggedUser.user.imageName
                        }
                        alt="DocImg"
                        className="rounded-full md:w-12 w-6 md:h-12 h-6"
                      />
                    </div>
                  ) : (
                    <div className="rounded-full border border-brand-secondaryColor md:w-12 w-10 md:h-12 h-10 ml-6 flex justify-center items-center">
                      <FaUser className="md:w-8 w-6 md:h-8 h-6" />
                    </div>
                  )}
                  <p className="text-white font-bold text-sm mb-0">
                    {`${profileData?.user.salutation} ${profileData?.user.firstName} ${profileData?.user.lastName}`}
                  </p>
                  <p className="text-white font-bold text-xs mb-0 ">
                    {profileData?.user.email}
                  </p>
                </div>
                <span className="flex flex-col gap-2 mt-2 ">
                  {location.pathname !== APP_ROUTES.VIDEOCALL ? (
                    <span
                      className="flex gap-2 p-1 rounded-md hover:border hover:border-[#189FAA]"
                      onClick={showModal}
                    >
                      <img src={profileIcon} alt="" /> <span>My Profile</span>
                    </span>
                  ) : (
                    <span className="flex gap-2 p-1 cursor-not-allowed rounded-md hover:border hover:border-[#189FAA]">
                      <img src={profileIcon} alt="" /> <span>My Profile</span>
                    </span>
                  )}
                  <span
                    className="flex gap-2 p-1 rounded-md hover:border hover:border-[#189FAA]"
                    onClick={handleLogout}
                  >
                    <img src={profileLogout} alt="" /> <span>Logout</span>
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <Modal
          title={
            <div className="flex justify-between ">
              <h2 className="font-bold text-xl">My Profile</h2>
              <div className="flex gap-1">
                <button
                  className="px-2 bg-gray-400 cursor-not-allowed text-white font-normal rounded"
                // onClick={handleDisabled}
                >
                  Request for Edit
                </button>
                <button
                  onClick={handleCancel}
                  className="p-1 bg-white text-black border-2"
                >
                  X
                </button>
              </div>
            </div>
          }
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={[]}
          width="70%"
          style={{
            top: "10%",
          }}
          closeIcon={false}
        >
          <MyProfile closeModal={handleOk} setIsModalOpen={setIsModalOpen} />
        </Modal>
      )}
      <Drawer
        title={<div className="text-2xl">Doxzon</div>}
        onClose={onClose}
        open={open}
        placement="left"
        width="50%"
        style={{
          backgroundColor: "whitesmoke",
        }}
      >
        <div className="">
          <ul className="text-base font-medium">
            <li
              className="mb-4"
              onClick={() => handleNavigation(APP_ROUTES.DASHBOARD)}
            >
              Dashboard
            </li>
            <li
              className="mb-4"
              onClick={() => handleNavigation(APP_ROUTES.APPOINTMENTS)}
            >
              Appointments
            </li>
            <li
              className="mb-4"
              onClick={() => handleNavigation(APP_ROUTES.PATIENTS)}
            >
              Patients
            </li>
            <li
              className="mb-4"
              onClick={() => handleNavigation(APP_ROUTES.PAYMENTS)}
            >
              Payments
            </li>
            <li
              className="mb-4"
              onClick={() => handleNavigation(APP_ROUTES.BILLINGREPORTS)}
            >
              Billing Reports
            </li>
            <li
              className="mb-4"
              onClick={() => handleNavigation(APP_ROUTES.ORDERREPORT)}
            >
              Order Reports
            </li>
            <li
              className="mb-4"
              onClick={() => handleNavigation(APP_ROUTES.SETTINGS)}
            >
              Change Password
            </li>
            <li
              className="mb-4"
              onClick={() => handleNavigation(APP_ROUTES.LOGINFORM)}
            >
              Logout
            </li>
          </ul>
        </div>
      </Drawer>
      <Drawer
        closeIcon={false}
        open={chatOpen}
        destroyOnClose
        onClose={handleChatClose}
      >
        <LiveChat />
        {/* <DoctorLiveChat doctorId={loggedUser.user.userId} doctorMeta={loggedUser.user}/> */}
      </Drawer>
      {clinicModal && (
        <Modal
          title="Change Default Clinic"
          open={clinicModal}
          onOk={handleClinicOk}
          onCancel={handleClinicCancel}
          footer={[]}
          width={300}
        >
          Do you Want to change
          <span className="font-bold">{selectedClinic.clinicName}</span> as your
          default Clinic
          <div className="flex justify-center gap-2 mt-2">
            <button className="bg-white  w-24 p-1 h-8 rounded-md border border-[#189FAA]">
              Cancel
            </button>
            <button
              onClick={handleClinicOk}
              className="bg-blue-500 w-24 p-1 h-8 text-white rounded-md border border-[#189FAA]"
            >
              Ok
            </button>
          </div>
        </Modal>
      )}
      {registrationModal && (
        <Modal
          title={
            <span className="text-base font-sans font-bold">
              New Patient Registration
            </span>
          }
          open={registrationModal}
          onCancel={handleRegistrationCancel}
          footer={[]}
          width="60%"
          style={{
            top: "0",
          }}
        >
          <RPMPatientRegistration
            handleCancel={handleRegistrationCancel}
            handleSave={handleRegistrationCancel}
          />
        </Modal>
      )}
      <div className="absolute top-4 right-4"></div>
    </div>
  );
}

export default Header;
